import { MultiLangHeaderStructure, SEPARATOR } from './types';

export const headerStructure: MultiLangHeaderStructure = {
  nav: [
    {
      text: 'menu_features',
      name: 'features_solutions',
      subs: [
        {
          text: 'sub_menu_design',
          href: {
            en: 'https://www.editorx.com/features/design',
            ru: 'https://ru.editorx.com/features/design',
            fr: 'https://fr.editorx.com/features/design',
            es: 'https://es.editorx.com/features/design',
            pt: 'https://pt.editorx.com/features/design',
            de: 'https://de.editorx.com/features/design',
            ja: 'https://ja.editorx.com/features/design',
          },
          name: 'design',
          subs: [],
        },
        {
          text: 'sub_menu_business_solutions',
          href: {
            en: 'https://www.editorx.com/features/business-ecommerce',
            ru: 'https://ru.editorx.com/features/business-ecommerce',
            fr: 'https://fr.editorx.com/features/business-ecommerce',
            es: 'https://es.editorx.com/features/business-ecommerce',
            pt: 'https://pt.editorx.com/features/business-ecommerce',
            de: 'https://de.editorx.com/features/business-ecommerce',
            ja: 'https://ja.editorx.com/features/business-ecommerce',
          },
          name: 'business_solutions',
          subs: [],
        },
        {
          text: 'sub_menu_collaboration',
          href: {
            en: 'https://www.editorx.com/collaboration',
            ru: 'https://ru.editorx.com/collaboration',
            fr: 'https://fr.editorx.com/collaboration',
            es: 'https://es.editorx.com/collaboration',
            pt: 'https://pt.editorx.com/collaboration',
            de: 'https://de.editorx.com/collaboration',
            ja: 'https://ja.editorx.com/collaboration',
          },
          name: 'collaboration',
          subs: [],
        },
        {
          text: 'sub_menu_development',
          href: {
            en: 'https://www.editorx.com/features/development',
            ru: 'https://ru.editorx.com/features/development',
            fr: 'https://fr.editorx.com/features/development',
            es: 'https://es.editorx.com/features/development',
            pt: 'https://pt.editorx.com/features/development',
            de: 'https://de.editorx.com/features/development',
            ja: 'https://ja.editorx.com/features/development',
          },
          name: 'development',
          subs: [],
        },
        {
          text: 'sub_menu_marketing_seo',
          href: {
            en: 'https://www.editorx.com/features/marketing-seo',
            ru: 'https://ru.editorx.com/features/marketing-seo',
            fr: 'https://fr.editorx.com/features/marketing-seo',
            es: 'https://es.editorx.com/features/marketing-seo',
            pt: 'https://pt.editorx.com/features/marketing-seo',
            de: 'https://de.editorx.com/features/marketing-seo',
            ja: 'https://ja.editorx.com/features/marketing-seo',
          },
          name: 'marketing_seo',
          subs: [],
        },
        {
          text: 'sub_menu_web_solutions',
          href: {
            en: 'https://www.editorx.com/features/web-solutions',
            ru: 'https://ru.editorx.com/features/web-solutions',
            fr: 'https://fr.editorx.com/features/web-solutions',
            es: 'https://es.editorx.com/features/web-solutions',
            pt: 'https://pt.editorx.com/features/web-solutions',
            de: 'https://de.editorx.com/features/web-solutions',
            ja: 'https://ja.editorx.com/features/web-solutions',
          },
          name: 'web_solutions',
          subs: [],
        },
        {
          text: 'sub_menu_releases_updates',
          href: 'https://www.editorx.com/features/releases-and-updates',
          name: 'releases_updates',
          target: '_blank',
          subs: [],
        },
      ],
    },
    {
      text: 'menu_inspiration',
      name: 'inspiration',
      subs: [
        {
          text: 'sub_menu_showroom',
          href: 'https://www.editorx.com/inspiration',
          name: 'showroom',
          target: '_blank',
          subs: [],
        },
        {
          text: 'sub_menu_shaping_design',
          href: 'https://www.editorx.com/shaping-design',
          target: '_blank',
          name: 'shaping_design',
          subs: [],
        },
        {
          text: 'sub_menu_case_studies',
          href: 'https://www.editorx.com/case-studies',
          name: 'case_studies',
          lang: ['en']
        },
      ],
    },
    {
      text: 'menu_resources',
      name: 'resources',
      subs: [
        {
          text: 'sub_menu_website_templates',
          href: {
            en: 'https://www.editorx.com/website-templates',
            ru: 'https://ru.editorx.com/website-templates',
            fr: 'https://fr.editorx.com/website-templates',
            es: 'https://es.editorx.com/website-templates',
            pt: 'https://pt.editorx.com/website-templates',
            de: 'https://de.editorx.com/website-templates',
            ja: 'https://ja.editorx.com/website-templates',
          },
          name: 'website_templates',
          subs: [],
        },
        {
          text: 'sub_menu_academy_x',
          href: 'https://www.editorx.com/academy',
          name: 'academy_x',
          target: '_blank',
          subs: [],
        },
        {
          text: 'sub_menu_design_classes',
          href: 'https://www.editorx.com/academy/design-classes',
          name: 'design_classes',
          target: '_blank',
          subs: [],
        },
        {
          text: 'sub_menu_webinars',
          href: 'https://www.editorx.com/academy/webinars',
          name: 'webinars',
          target: '_blank',
          subs: [],
        },
        {
          text: 'sub_menu_community_x',
          href: 'https://www.editorxcommunity.com',
          target: '_blank',
          name: 'community_x',
          subs: [],
        },
      ],
    },
    {
      text: 'menu_pricing',
      name: 'pricing',
      subs: [
        {
          text: 'sub_menu_pricing_plans',
          href: {
            en: 'https://www.editorx.com/upgrade/website',
            ru: 'https://ru.editorx.com/upgrade/website',
            fr: 'https://fr.editorx.com/upgrade/website',
            es: 'https://es.editorx.com/upgrade/website',
            pt: 'https://pt.editorx.com/upgrade/website',
            de: 'https://de.editorx.com/upgrade/website',
            ja: 'https://ja.editorx.com/upgrade/website',
          },
          name: 'pricing_plans',
          subs: [],
        },
        {
          text: 'sub_menu_enterprise',
          href: 'https://www.editorx.com/enterprise',
          name: 'enterprise',
          target: '_blank',
          subs: [],
        },
      ],
    },
    {
      text: 'menu_partner',
      href: {
        en: 'https://www.wix.com/partners',
        ru: 'https://ru.wix.com/partners',
        fr: 'https://fr.wix.com/partners',
        es: 'https://es.wix.com/partners',
        pt: 'https://pt.wix.com/partners',
        de: 'https://de.wix.com/partners',
        ja: 'https://ja.wix.com/partners',
      },
      target: '_blank',
      name: 'become_partner',
      subs: [],
    },
  ],
  languagePickerMenu: [
    {
      text: 'English',
      name: 'en',
    },
    {
      text: 'Deutsch',
      name: 'de',
    },
    {
      text: 'Español',
      name: 'es',
    },
    {
      text: 'Français',
      name: 'fr',
    },
    {
      text: '日本語',
      name: 'ja',
    },
    {
      text: 'Português',
      name: 'pt',
    },
    {
      text: 'Русский',
      name: 'ru',
    },
  ],
  startNowButton: {
    text: 'menu_sign_in',
    href:
      'https://users.editorx.com/signin?loginCompName=Signup_H&referralInfo=Editorx_Signup_H&sendEmail=true&view=sign-up&postLogin=https:%2F%2Fmanage.editorx.com%2Faccount%2Fsites&forceRender=true',
  },
  userMenu: [
    {
      text: 'menu_account_settings',
      name: 'account_settings',
      href: 'https://manage.editorx.com/account/account-settings',
      subs: [],
    },
    {
      text: 'menu_billing_and_payments',
      name: 'billing_payments',
      href: 'https://manage.editorx.com/wix/api/PaymentConsole',
      subs: [],
    },
    {
      text: 'menu_vouchers',
      name: 'vouchers',
      href: 'https://manage.editorx.com/account/vouchers',
      subs: [],
    },
    SEPARATOR,
    {
      text: 'menu_my_sites',
      name: 'my_sites',
      href: 'https://manage.editorx.com/account/sites',
      subs: [],
    },
    {
      text: 'menu_create_new_site',
      name: 'create_new_site',
      href: 'https://manage.editorx.com/create-site?ref=editorx-header',
      subs: [],
    },
    SEPARATOR,
    {
      text: 'menu_logout',
      name: 'signout',
      href: 'https://manage.editorx.com/signout',
      subs: [],
    },
  ],
};
